import { useContext } from 'react';
import { GenericModalContext } from '../components/context/GenericModalContextProvider';

const useLoader = () => {
  const { handleLoader } = useContext(GenericModalContext);
  return { handleLoader };
};

export default useLoader;
